import { generatePath } from 'react-router-dom'

export const API_METHODS = { POST: 'POST', GET: 'GET', PUT: 'PUT', DELETE: 'DELETE' }

export const routes = {
    publicIndex: { path: '/', label: 'Home' },
    privacyPolicy: { path: '/privacy-policy/', label: 'Privacy Policy' },
    router: { path: '/router/', label: '' },

    authLogin: { path: '/login/', label: 'Login' },
    authLogout: { path: '/logout/', label: 'Logout' },
    authRegister: { path: '/register/', label: 'Register' },
    authPasswordHelp: { path: '/password-help/', label: 'Password Help' },
    authPasswordReset: { path: '/password-reset/', label: 'Password Reset' },
    authHandler: { path: '/auth-handler/', label: '' },
    authWelcome: { path: '/welcome/', label: 'Welcome' },

    appIndex: { path: '/app/', label: 'Dashboard' },
    appTrucksView: { path: '/app/trucks/:truckId/', label: 'Trucks' },
    appTrucksStep: { path: '/app/trucks/:truckId/step/', label: 'Step' },

    appInstallationIndex: { path: '/app/installation/', label: 'Installations' },
    appInstallationCreate: { path: '/app/installation/create/', label: 'Create Installation' },
    appInstallationView: { path: '/app/installation/:installId/', label: 'Installation' },

    appSettingsIndex: { path: '/app/settings/', label: 'Settings' },
    appUserIndex: { path: '/app/user/', label: 'Profile' },
    appTeamIndex: { path: '/app/team/', label: 'Team' },
    appCreateUser: { path: '/app/team/create/', label: 'Create User' },
    appTeamMemberView: { path: '/app/team/:userId/', label: 'Team Member Profile' },

    adminIndex: { path: '/admin/', label: 'Admin' },
    adminAccountsIndex: { path: '/admin/accounts/', label: 'Accounts' },
    adminAccountDashboard: { path: '/admin/accounts/:accountId/dashboard/', label: 'Account Dashboard' },
    adminAccountCreate: { path: '/admin/accounts/create/', label: 'Create Account' },
    adminAccountView: { path: '/admin/accounts/:accountId/', label: 'Account Details' },

    adminImeiIndex: { path: '/admin/accounts/:accountId/imeis/', label: 'IMEIs' },
    adminImeiCreate: { path: '/admin/accounts/:accountId/imeis/create/', label: 'Create IMEI' },

    adminUsersIndex: { path: '/admin/accounts/:accountId/users/', label: 'Users' },
    adminUsersCreate: { path: '/admin/accounts/:accountId/users/create/', label: 'Create User' },
    adminUsersView: { path: '/admin/accounts/:accountId/users/:userId/', label: 'User Details' },

    adminTrucksIndex: { path: '/admin/trucks/', label: 'Trucks' },

    adminManualBuilderIndex: { path: '/admin/manuals/build/:manualId/:versionId/', label: 'Builder' },
    adminManualBuilderStep: { path: '/admin/manuals/build/:manualId/:versionId/:stepId/', label: 'Builder: Step' },
    adminManualBuilderSubstep: { path: '/admin/manuals/build/:manualId/:versionId/:stepId/:substepId', label: 'Builder: Substep' },

    adminManualsIndex: { path: '/admin/manuals/', label: 'Manuals' },
    adminManualsCreate: { path: '/admin/manuals/create/', label: 'Create Manual' },
    // adminManualsView: { path: '/admin/manuals/:manualId/:versionId/', label: 'View' },
    // adminManualsStepView: { path: '/admin/manuals/:manualId/:versionId/step/:stepId/', label: 'Step' },
    adminManualsStep: { path: '/admin/manuals/:manualId/:versionId/:stepId/', label: 'Manual Step' },
    adminManualsView: { path: '/admin/manuals/:manualId/:versionId/', label: 'Manual Details' },
    adminManualsSubstep: { path: '/admin/manuals/:manualId/:versionId/:stepId/:substepId', label: 'Manual Substep' },

    adminTemplateIndex: { path: '/admin/templates/', label: 'Templates' },
    adminTemplateView: { path: '/admin/templates/:templateId/', label: 'Template Details' },
    adminTemplateCreate: { path: '/admin/templates/create/', label: 'Create Template' },

    adminInstallationIndex: { path: '/admin/installation/', label: 'Installations' },
    adminInstallationView: { path: '/admin/installation/:installId/', label: 'Installation Details' },
    adminInstallationCreate: { path: '/admin/installation/create/', label: 'Create Installation' },

    adminTemplateGroupIndex: { path: '/admin/template-group/', label: 'Template Groups' },
    adminTemplateGroupView: { path: '/admin/template-group/:groupId/', label: 'Group Details' },
    adminTemplateGroupCreate: { path: '/admin/template-group/create/', label: 'Create Group' },
    adminTemplateGroupEdit: { path: '/admin/templates/:templateId/template-group/:groupId/', label: 'Edit Group' },

    adminQuestionView: { path: '/admin/template-group/:groupId/question/:questionId/', label: 'Question Details' },
    adminQuestionIndex: { path: '/admin/questions/', label: 'Questions' },
    adminQuestionCreate: { path: '/admin/questions/create/', label: 'Create Question' },
    adminQuestionEdit: { path: '/admin/questions/:questionId/', label: 'Question Details' },

    createUser: { path: '/create-user/', label: '' },

    appCaptureImage: { path: '/app/test/', label: 'Capture Image' },
    appCaptureImageWebcam: { path: '/app/test2/', label: 'Capture Image Webcam' }
}

export const apiResourceEndpoint = (resource, action, id = null, extraPath = '') => {
    let routeObj = {
        url: `/${resource}/`,
        method: API_METHODS.GET
    }
    // adjust the route
    if (action === 'UPDATE' || action === 'VIEW' || action === 'DELETE') {
        routeObj.url = routeObj.url + `${id}/`
    }
    // adjust the medthod
    if (action === 'CREATE' || action === 'UPDATE') {
        routeObj.method = API_METHODS.POST
    } else if (action === 'DELETE') {
        routeObj.method = API_METHODS.DELETE
    }
    // do we need to append any extra stuff to the url
    if (extraPath !== '') {
        routeObj.url = routeObj.url + extraPath + '/'
    }
    return routeObj
}

export const nestedRoutePath = (parent, route, isParent = false) => {
    let nestedRoute = route.substr(parent.length)
    if (isParent) {
        nestedRoute = nestedRoute + '*'
    }
    return nestedRoute
}

export const buildRoutePath = (route, params = {}) => {
    return generatePath(route, params)
}
